import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import '@/router/config'

import 'normalize.css/normalize.css'
import './assets/styles/element-variables.scss'
import './assets/styles/index.scss'

import Element from 'element-ui'

import './assets/icons' // icon
import 'echarts-gl'

import uploader from 'vue-simple-uploader'

import Local from '@/utils/local'

import checkPermission from '@/utils/permission'

import permission from './directive/permission'

// 注册滚动条加载触发事件v-more绑定
import more from './directive/select'

// https://blog.csdn.net/asing1elife/article/details/82796652
// Vue集成highlight.js
// 因为vue-highlightjs 很久没更新过了，所以以后有时间可以考虑自己集成highlightjs
import VueHighlightJS from 'vue-highlightjs'
import 'highlight.js/styles/atom-one-dark.css'
// import 'highlight.js/styles/atom-one-light.css'

Vue.use(uploader)

Vue.use(VueHighlightJS)

Vue.use(checkPermission)

Vue.use(permission)

Vue.use(more)

Vue.use(Element, {
  size: 'small' // 设置 Element UI 默认显示大小；如果需要支持动态设置显示尺寸，可扩展
})

Vue.use(Local)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
